import type { CSSProperties, MouseEvent, ReactNode } from 'react';

import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './MiniCardLayout.module.scss';

const cls = cssModules(STYLES);

type MiniCardLayoutProps = {
  url?: string;
  className?: string;
  style?: CSSProperties;
  selected?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onHover?: () => void;
  showPrice?: boolean;
  isVertical?: boolean;
  imageNode: ReactNode;
  hotelNameNode: ReactNode;
  starsNode?: ReactNode;
  reviewRatingNode: ReactNode;
  distanceOrPriceNode?: ReactNode;
};

const MiniCardLayout = ({
  className,
  distanceOrPriceNode,
  hotelNameNode,
  imageNode,
  isVertical,
  onClick,
  onHover,
  reviewRatingNode,
  selected,
  showPrice,
  starsNode,
  style,
  url,
}: MiniCardLayoutProps) => (
  <BpkCard
    href={url}
    padded={false}
    onClick={onClick}
    target="_blank"
    rel="opener"
    className={cls(
      'MiniCardLayout',
      selected && 'MiniCardLayout--selected',
      showPrice && 'MiniCardLayout--withPrice',
      isVertical && 'MiniCardLayout--vertical',
      className,
    )}
    style={style}
    onMouseEnter={onHover}
  >
    <div
      className={cls(
        'MiniCardLayout__imageInfo',
        isVertical && 'MiniCardLayout__imageInfo--vertical',
      )}
    >
      {imageNode}
    </div>
    <div
      className={cls(
        'MiniCardLayout__baseInfo',
        showPrice && 'MiniCardLayout__baseInfo--withPrice',
        isVertical && 'MiniCardLayout__baseInfo--vertical',
      )}
    >
      <div className={cls('MiniCardLayout__hotelAndStars')}>
        <div className={cls('MiniCardLayout__hotelName')}>{hotelNameNode}</div>
        {starsNode}
      </div>
      <div
        className={cls(
          'MiniCardLayout__ratingAndDistanceInfo',
          showPrice && 'MiniCardLayout__ratingAndDistanceInfo--withPrice',
        )}
      >
        {reviewRatingNode}
        <div
          className={cls(
            'MiniCardLayout__distanceInfo',
            showPrice && 'MiniCardLayout__priceInfo',
          )}
        >
          {distanceOrPriceNode}
        </div>
      </div>
    </div>
  </BpkCard>
);

export default MiniCardLayout;
